export default __webpack_public_path__ + "static/media/intro-questionnaire.49e3f510.png";